import { fetchContentAssistanceSettings } from '../api/ContentAssistant';
import { FETCH_CONTENT_ASSISTANT_SETTINGS_PENDING, FETCH_CONTENT_ASSISTANT_SETTINGS_SUCCESS, FETCH_CONTENT_ASSISTANT_SETTINGS_ERROR } from './ActionTypes';
export const getContentAssistantSettings = () => dispatch => {
  dispatch({
    type: FETCH_CONTENT_ASSISTANT_SETTINGS_PENDING
  });
  return fetchContentAssistanceSettings().then(response => {
    dispatch({
      type: FETCH_CONTENT_ASSISTANT_SETTINGS_SUCCESS,
      payload: response
    });
  })
  // fallback to contentAssistanceEnabled=false when request fails
  .catch(() => {
    dispatch({
      type: FETCH_CONTENT_ASSISTANT_SETTINGS_ERROR,
      payload: {
        contentAssistanceEnabled: false
      }
    });
  });
};